// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content .el-link {\n  margin: 0 5px;\n}\n/deep/.el-scrollbar {\n  height: 10px;\n}\n/deep/.el-scrollbar__bar.is-horizontal {\n  height: 9px;\n}\n", ""]);
// Exports
module.exports = exports;
